var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssignment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0007,
    cy: 20,
    r: 16.6667,
    fill: "#1A73E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1954 10.7143C13.4482 10.7143 12.8574 11.3224 12.8574 12.0522V27.8121C12.8574 28.5592 13.4656 29.15 14.1954 29.15H26.4974C27.2446 29.15 27.8354 28.5419 27.8354 27.8121V15.649L22.9006 10.7143H14.1954ZM26.6885 27.8295C26.6885 27.9337 26.6017 28.0206 26.4974 28.0206H14.1954C14.0911 28.0206 14.0042 27.9337 14.0042 27.8295V12.0522C14.0042 11.948 14.0911 11.8611 14.1954 11.8611H21.9276V15.2668C21.9276 16.0139 22.5357 16.6047 23.2655 16.6047H26.6885V27.8295ZM23.0744 12.5388L26.0109 15.4753H23.2655C23.1613 15.4753 23.0744 15.3884 23.0744 15.2841V12.5388Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7383 18.1862H23.6886",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7383 21.6614H23.6886",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7383 25.1362H23.6886",
    stroke: "white",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/Assignment.b6d297ab.svg";
export { ForwardRef as ReactComponent };